<div id="wrapper" class="background mtv-body-color" (document:keydown.control.q)="showParcelPickup()">
    <navigation *ngIf="authenticationService.user" class="sidebar-menu"></navigation>
    <div id="page-wrapper"
         [style.background-image]="getBackground(residentService.selectedBuilding.backgroundIMG)"
         class="gray-bg mtv-body-color"
         [ngClass]="[authenticationService.userIsResident ? 'resident' : '']">
        <top-nav-bar></top-nav-bar>
        <router-outlet *ngIf="authenticationService.user"></router-outlet>
        <spinner [spinnerShow]="!authenticationService.user"></spinner>
        <app-modal></app-modal>
        <contact-us-modal *ngIf="residentService.contactUsModalShow"></contact-us-modal>
        <no-buildings-modal *ngIf="residentService.showNoBuildingsModal"></no-buildings-modal>
        <enter-parcel-barcode-modal  *ngIf="parcelsService.isEnterParcelBarcodeModalShow"></enter-parcel-barcode-modal>
        <transit-parcel-modal  *ngIf="parcelsService.isTransitModalShow && router.url.indexOf('parcels') == -1">
        </transit-parcel-modal>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/layouts/basic/basic.component.html